const toolHolderInputTypes = {
  URL: "url",
  ISO: "iso",
};

export default toolHolderInputTypes;
